// Genera id rapido e sufficientemente unico
export const genId = (prefix = 'id') => `${prefix}_${Date.now()}_${Math.floor(Math.random() * 10000)}`;

// Validazione URL: accetta solo domini semplici (es. example.com, sub.example.com)
// Non accetta protocolli (https://) né wildcard (*.example.com)
export const validateUrl = (u) => {
    if (!u) return false;
    const trimmed = u.trim();
    if (/\s/.test(trimmed)) return false;

    // Rifiuta se contiene protocolli
    if (/^https?:\/\//i.test(trimmed)) return false;

    // Rifiuta se contiene wildcard
    if (/\*/.test(trimmed)) return false;

    // Accetta solo nomi di dominio validi (es. example.com, sub.example.com)
    // Pattern: label.label.label... dove ogni label è alfanumerico e trattini
    const domainPattern = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
    return domainPattern.test(trimmed);
};

// Helper centralizzato per chiamate POST API con pattern form-urlencoded
export const postApi = async (envKey, payload, { signal, mock } = {}) => {
    const url = process.env[envKey];
    if (!url) {
        if (mock) return mock();
        return null;
    }
    const formBody = `payload=${encodeURIComponent(JSON.stringify(payload))}`;
    const response = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        body: formBody,
        signal
    });
    const data = await response.json();
    if (!response.ok || data.statusRequest !== 'success') {
        throw new Error(data.message || `Errore HTTP: ${response.status}`);
    }
    return data;
};